export default {
  english: {
    changeImage: 'Change profile image',
    error: 'An error occurred, please retry',
    fileTooLarge: 'The image must not exceed {{ size }}MB',
    invalidType: 'Only {{ types }} images supported',
    uploaded: 'Image saved',
    avatar: 'Avatar',
  },
  french: {
    changeImage: 'Changer l\'image de profil',
    error: 'Une erreur s\'est produite, veuillez réessayer',
    fileTooLarge: 'L\'image ne doit pas dépasser {{ size }}Mo',
    invalidType: 'Images {{ types }} uniquement',
    uploaded: 'Image enregistrée',
    avatar: 'Avatar',
  },
  arabic: {
    changeImage: 'تغيير صورة البروفايل',
    error: 'وقع خطأ يرجى اعادة المحاولة',
    fileTooLarge: 'الصورة لا تكون اكبر من  {{ size }}MB',
    invalidType: 'فقط {{ types }} تدعم الانساق',
    uploaded: 'تم حفظ الصورة',
    avatar: 'الصورة الرمزية',
  },
  hebrew: {
    changeImage: 'החלף תמונת פרופיל',
    error: 'אירעה שגיאה, אנא נסה שנית',
    fileTooLarge: 'התמונה לא תעלה על {{ size }}MB',
    invalidType: 'רק תמונות {{ types }} נתמכות',
    uploaded: 'תמונה נשמרה',
    avatar: 'אווטאר',
  },
  persian: {
    changeImage: 'تغییر تصویر پروفایل',
    error: 'خطایی روی داد، لطفا دوباره امتحان کنید',
    fileTooLarge: 'تصویر نباید بیشتر از {{ size }} مگابایت باشد',
    invalidType: 'فقط {{ types }} تصویر پشتیبانی می شود',
    uploaded: 'تصویر ذخیره شد',
    avatar: 'آواتار',
  },
}
